import { ref } from 'vue';
<template>
  <section class="livratos-double-section">
    <div class="container">
      <h3 className="">Plus de détail ?</h3>
      <!-- Étape 1 : Inscription -->
      <div class="livratos-row">
        <div class="livratos-col">
          <div class="livratos-image-card">
            <img
              src="@/assets/pictures/register-livratos.webp"
              alt="Inscription du fournisseur sur la plateforme Livratos"
              class="img-fluid"
            />
          </div>
        </div>
        <div class="livratos-col">
          <div class="livratos-text-card">
            <p class="badge">Étape 1 • Inscription</p>
            <h2>
              Créez votre espace<br />
              fournisseur Livratos
            </h2>
            <p>
              L’inscription est simple et rapide : vous ouvrez votre compte en
              quelques secondes, puis vous accédez à votre espace personnel pour
              compléter les informations essentielles de votre entreprise. C’est
              ici que vous indiquez votre structure, votre zone d’activité et
              les éléments nécessaires à l’activation de votre service. Une fois
              votre profil complété, notre équipe vous contacte pour finaliser
              la mise en route, répondre à vos questions, vous présenter la
              plateforme si besoin et vous accompagner jusqu’au lancement
              opérationnel.
            </p>

            <ul class="features-list">
              <li>
                Un espace fournisseur facile à prendre en main, pensé pour les
                dépôts BTP.
              </li>
              <li>
                Un profil entreprise complet : coordonnées professionnelles,
                documents officiels, zone d’activité Livratos.
              </li>
              <li>
                Accompagnement personnalisé avant l’activation (appel, démo,
                aide au paramétrage).
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Étape 2 : Activation du compte -->
      <div class="livratos-row reverse">
        <div class="livratos-col">
          <div class="livratos-image-card">
            <img
              src="@/assets/pictures/register-livratos-2.webp"
              alt="Activation du compte fournisseur par l’équipe Livratos"
              class="img-fluid"
            />
          </div>
        </div>
        <div class="livratos-col">
          <div class="livratos-text-card">
            <p class="badge">Étape 2 • Activation</p>
            <h2>
              Validation par nos équipes,<br />
              paramétrage de votre dépôt
            </h2>
            <p>
              Une fois votre profil complété, notre équipe vérifie vos
              informations et revient vers vous pour finaliser l’activation de
              votre espace fournisseur. Cet échange nous permet de nous assurer
              que tout est en ordre, de répondre à vos questions et, si vous le
              souhaitez, de vous présenter la plateforme ou de vous accompagner
              sur les premiers pas. Dès validation, votre compte est activé et
              vous pouvez commencer à organiser vos livraisons.
            </p>

            <ul class="features-list">
              <li>
                Contrôle des informations <strong>fournisseur</strong> et
                validation de votre profil.
              </li>
              <li>
                Appel de bienvenue&nbsp;: explications, démo si besoin et aide
                au paramétrage initial.
              </li>
              <li>
                Accompagnement de démarrage (prise en main rapide par vos
                équipes).
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Étape 3 : Création des livraisons -->
      <div class="livratos-row">
        <div class="livratos-col">
          <div class="livratos-image-card">
            <img
              src="@/assets/pictures/chargement-item.webp"
              alt="Création d’une livraison depuis le comptoir fournisseur"
              class="img-fluid"
            />
          </div>
        </div>
        <div class="livratos-col">
          <div class="livratos-text-card">
            <p class="badge">Étape 3 • Création des livraisons</p>
            <h2>
              Depuis votre comptoir,<br />
              déclenchez vos livraisons rapidement
            </h2>
            <p>
              Au moment de la commande, votre équipe crée une
              <strong>livraison</strong> directement dans Livratos&nbsp;: dépôt
              de départ, <strong>chantier de destination</strong>, type de
              véhicule et nature du chargement. La plateforme affecte un
              <strong>livreur indépendant</strong> adapté et vous suivez le
              statut jusqu’à la remise au client.
            </p>
            <ul class="features-list">
              <li>
                Création de
                <strong>livraisons express ou programmées</strong> depuis la
                même interface.
              </li>
              <li>
                Saisie guidée&nbsp;: adresse <strong>chantier</strong>, contact
                sur place, SMS de confirmation pour le destinataire.
              </li>
              <li>
                Suivi des statuts en temps réel (en attente, en transit,
                <strong>livrée</strong>, interrompue).
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Étape 4 : Facturation -->
      <div class="livratos-row reverse">
        <div class="livratos-col">
          <div class="livratos-image-card">
            <img
              src="@/assets/pictures/billing-delivery.webp"
              alt="Facturation regroupée des livraisons fournisseur"
              class="img-fluid"
            />
          </div>
        </div>
        <div class="livratos-col">
          <div class="livratos-text-card">
            <p class="badge">Étape 4 • Facturation</p>
            <h2>
              Toutes vos courses regroupées,<br />
              une facturation simple
            </h2>
            <p>
              Les <strong>livraisons</strong> réalisées via Livratos sont
              regroupées sur une période définie (tous les 8&nbsp;jours ou en
              fin de mois selon votre organisation). Vous recevez une facture
              unique avec le détail des courses,
              <strong>chantiers livrés</strong> et montants associés, prête à
              être intégrée en comptabilité.
            </p>
            <ul class="features-list">
              <li>
                Factures PDF récapitulatives avec détail des
                <strong>livraisons</strong>.
              </li>
              <li>
                Suivi des statuts (payé / en attente) directement dans votre
                espace.
              </li>
              <li>
                Moins d’administratif&nbsp;: pas de paiements au coup par coup à
                chaque course.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "LivratosDoubleSectionFournisseurs",
};
</script>

<style lang="scss" scoped>
.livratos-double-section {
  background-color: $background; // section blanche
  padding: 80px 20px;

  .container {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 60px;

    @media (min-width: 992px) {
      gap: 80px;
    }
  }

  .livratos-row {
    display: flex;
    flex-direction: column;
    gap: 24px;

    @media (min-width: 992px) {
      flex-direction: row;
      gap: 32px;
      align-items: stretch; // mêmes hauteurs
    }

    &.reverse {
      @media (min-width: 992px) {
        flex-direction: row-reverse;
      }
    }

    .livratos-col {
      flex: 1;
      display: flex; // pour étirer la card
      align-items: stretch;
    }

    /* CARD IMAGE (fond vert) */
    .livratos-image-card {
      background-color: $color-primary;
      border-radius: 16px;
      padding: 3px;
      width: 100%;
      box-shadow: 0 18px 40px rgba(0, 0, 0, 0.18),
        0 6px 16px rgba(0, 0, 0, 0.12);

      display: flex;
      align-items: center;
      justify-content: center;

      @media (min-width: 992px) {
        padding: 22px;
      }

      img {
        width: 100%;
        border-radius: 12px;
        object-fit: cover;
        display: block;
      }
    }

    /* CARD TEXTE (fond noir, texte blanc) */
    .livratos-text-card {
      background-color: #000;
      border-radius: 16px;
      padding: 22px 22px 24px;
      width: 100%;
      color: #fff;
      box-shadow: 0 20px 45px rgba(0, 0, 0, 0.28), 0 8px 20px rgba(0, 0, 0, 0.2);

      @media (min-width: 768px) {
        padding: 26px 28px 30px;
      }

      .badge {
        display: inline-block;
        font-size: 0.75rem;
        text-transform: uppercase;
        letter-spacing: 0.08em;
        padding: 0.25rem 0.8rem;
        border-radius: 999px;
        background: rgba($color-primary, 0.18);
        color: $color-primary;
        font-weight: 600;
        margin-bottom: 0.85rem;
      }

      h2 {
        font-size: 1.6rem;
        font-weight: 700;
        color: #ffffff;

        @media (min-width: 768px) {
          font-size: 2.1rem;
        }
      }

      p {
        margin-top: 1rem;
        font-size: 0.98rem;
        color: rgba(255, 255, 255, 0.85);

        @media (min-width: 768px) {
          font-size: 1.05rem;
        }
      }

      .features-list {
        margin-top: 1.1rem;
        padding-left: 0;
        list-style: none;

        li {
          position: relative;
          padding-left: 1.2rem;
          margin-bottom: 0.4rem;
          font-size: 0.95rem;
          color: rgba(255, 255, 255, 0.85);

          &::before {
            content: "";
            position: absolute;
            left: 0;
            top: 0.55em;
            width: 7px;
            height: 7px;
            border-radius: 50%;
            background-color: $color-primary;
            transform: translateY(-50%);
            box-shadow: 0 0 0 2px rgba($color-primary, 0.25);
          }
        }
      }
    }
  }
}
</style>
